package com.tovtalk.utils.deeplink

import com.tovtalk.utils.logger.Logger

/** Tracks pending deep link for logging "arrived" / "not found" when the destination loads. */
object DeepLinkLogger {
    var pendingRoute: DeepLinkRoute? = null
        private set

    fun setPending(route: DeepLinkRoute) {
        pendingRoute = route
    }

    fun clearIfMatchesPost(postRef: String, arrived: Boolean) {
        val r = pendingRoute
        if (r is DeepLinkRoute.Post && r.postRef == postRef) {
            if (arrived) {
                Logger.i("[DeepLink] הגעה ליעד – פוסט ref=$postRef נטען בהצלחה", "DeepLink")
            } else {
                Logger.w("[DeepLink] המשאב לא נמצא – פוסט ref=$postRef", "DeepLink")
            }
            pendingRoute = null
        } else if (r is DeepLinkRoute.Video && r.postRef == postRef) {
            if (arrived) {
                Logger.i("[DeepLink] הגעה ליעד – סרטון ref=$postRef נטען בהצלחה", "DeepLink")
            } else {
                Logger.w("[DeepLink] המשאב לא נמצא – סרטון ref=$postRef", "DeepLink")
            }
            pendingRoute = null
        }
    }

    fun clearIfMatchesUser(username: String, arrived: Boolean) {
        val r = pendingRoute
        if (r is DeepLinkRoute.User && r.username.equals(username, ignoreCase = true)) {
            if (arrived) {
                Logger.i("[DeepLink] הגעה ליעד – משתמש @$username נטען בהצלחה", "DeepLink")
            } else {
                Logger.w("[DeepLink] המשאב לא נמצא – משתמש @$username", "DeepLink")
            }
            pendingRoute = null
        }
    }
}
